(function($){

  $.fn.chase = function(options) {

    var settings = $.extend({
      target: '.chased',
      currentItemClass: 'current',
      targetMarginTop: 0
    }, options);

    var $that = $(this);

    // if(window.location.hash.substr(1)) {
    //   $('a[href=' + window.location.hash + ']').click();
    // }

    $(window).on('load resize scroll', function (e) {
			var r = $(settings.target).filter(function (i, v) {
        // console.log($(v).offset().top)
        // console.log($(window).scrollTop())
        return $(v).offset().top - settings.targetMarginTop < $(window).scrollTop()
      }).length - 1

      return $that.removeClass(settings.currentItemClass).eq(0 < r  ? r : 0).addClass(settings.currentItemClass);
		});

  };
})(jQuery);
